import { useTranslation } from 'react-i18next'
import { ChangeEvent, useCallback, useEffect, useState } from 'react'

// import Tooltip from 'app/common/ui/Tooltip'
// import ConfirmationDialog from 'app/common/components/Confirmation/ConfirmationDialog'
// import PlainButtonAsLink from 'app/common/ui-next/plain-button-as-link'
// import PlainIcon, { iconType, iconColor } from 'app/common/ui-next/plain-icon'
import LineInput from 'app/common/ui/LineInput'

import styles from './LimitEditPerSalePoint.module.scss';


type Props = {
  ID: string
  currency: string
  targetName: string
  value: string | null
  onClearLimit: (ID: string) => void
  onModify: (val: boolean) => void
  loading?: boolean
  sending?: boolean
  resetKey: Array<never>
}

export const LimitEditPerSalePoint = ({
  ID,
  currency,
  targetName,
  value: limit,
  onClearLimit, // eslint-disable-line @typescript-eslint/no-unused-vars
  onModify,
  loading = false,
  sending = false,
  resetKey,
}: Props) => {
  const { t } = useTranslation('cafeteria')

  // const maxOfLimit = Infinity
  const [amount, setAmount] = useState('')
  const handleAmountChange = useCallback((e: ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target
    if (/^\d+(\.|,)?\d{0,2}$/.test(value) || value === '') {
      setAmount(value)
      onModify(true)
    }
  }, [onModify])

  useEffect(() => {
    setAmount('')
  }, [resetKey])

  const limitActive = limit !== null

  return (
    <div>
      <div className={styles.root}>
        {/* "Сумма лимита в «{{target}}»:" */}
        {t('settings_limit_summ_in', { target: targetName })}

        <span className={styles.limit}>
          {'\u00A0'}
          {limitActive
            ? <>
              {`${limit}\u00A0`}
              {/* "{{currency}}/день", */}
              {t('settings_limit_units', { currency })}
            </>
            : t('settings_limit_absent', 'Отсутствует')}
        </span>

        {/* {limitActive
          && <ConfirmationDialog
            onConfirm={() => onClearLimit(ID)}
            text={t('settings_limit_sell_point_delete_prompt', 'Удалить лимит для точки продаж на личные покупки?')}
            confirmButtonText={t('settings_limit_personal_delete_confirm', 'Да')}
            cancelButtonText={t('settings_limit_personal_delete_cancel', 'Отмена')}
          >
            {handleConfirm => (
              <Tooltip className={styles.crossTooltip} text={t('settings_limit_personal_delete_tooltip', 'Снять ограничение')}>
                <PlainButtonAsLink onClick={handleConfirm}>
                  <PlainIcon
                    type={iconType.LIGHT_CROSS}
                    color={iconColor.COLOR_GRAY}
                    className={styles.cross}
                    width={14}
                    height="auto"
                  />
                </PlainButtonAsLink>
              </Tooltip>
            )}
          </ConfirmationDialog>} */}
      </div>
      <LineInput
        name={`limit_${ID}`}
        className={styles.input}
        onChange={handleAmountChange}
        value={amount}
        placeholder={t('settings_limit_personal_set_placeholder', 'Введите сумму')}
        // максимальный уровень (maxOfLimit и exceedError) не используется пока для лимитов по точкам продаж
        // onFocus={() => setExceedError(false)}
        // isError={exceedError}
        // errorText={t('settings_limit_personal_set_error', {
        //   maxOfLimit: toFixedValueCurrency(maxOfLimit, false, currency),
        // })}
        loading={loading}
        disabled={sending}
      />

      {/* {exceedError && <div className={styles.space} />} */}
    </div>
  )
}
